/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResetPasswordReqVo
 */
export interface ResetPasswordReqVo {
    /**
     * 手机号
     * @type {string}
     * @memberof ResetPasswordReqVo
     */
    mobileNumber?: string;
    /**
     * 手机验证码
     * @type {string}
     * @memberof ResetPasswordReqVo
     */
    verificationCode?: string;
}

/**
 * Check if a given object implements the ResetPasswordReqVo interface.
 */
export function instanceOfResetPasswordReqVo(value: object): value is ResetPasswordReqVo {
    return true;
}

export function ResetPasswordReqVoFromJSON(json: any): ResetPasswordReqVo {
    return ResetPasswordReqVoFromJSONTyped(json, false);
}

export function ResetPasswordReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResetPasswordReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'mobileNumber': json['mobileNumber'] == null ? undefined : json['mobileNumber'],
        'verificationCode': json['verificationCode'] == null ? undefined : json['verificationCode'],
    };
}

export function ResetPasswordReqVoToJSON(json: any): ResetPasswordReqVo {
    return ResetPasswordReqVoToJSONTyped(json, false);
}

export function ResetPasswordReqVoToJSONTyped(value?: ResetPasswordReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mobileNumber': value['mobileNumber'],
        'verificationCode': value['verificationCode'],
    };
}

